import { GA } from '@t/components';

const createGA = (page: string, action: string, target: string, detail = ''): GA => ({
  category: `${page}`,
  action: `${action} ${target}`,
  label: `${target} - ${detail}`,
});

export default createGA;
